/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGcpFolder extends models.ServiceAccountNativeDetailsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGcpFolder");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGcpFolder.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGcpFolder>): ServiceAccountNativeDetailsForGcpFolder {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGcpFolder(), model);
        ServiceAccountNativeDetailsForGcpFolder.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGcpFolder>): ServiceAccountNativeDetailsForGcpFolder {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGcpFolder.newInstance(<ServiceAccountNativeDetailsForGcpFolder> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGcpFolder) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGcpFolder.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGcpFolder): boolean {
        if (models.ServiceAccountNativeDetailsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGcpFolder.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Folder Id. This is a required field.
     */
    folder_id: string;

    /**
     * Folder Name
     */
    folder_name: string;

}
